<template>
    <div>
        <dynamic-toolbar
            icon="mdi-account-group"
            title="Users"
            color="blue-grey darken-4"
            theme="dark"
        >
        </dynamic-toolbar>

        <v-card>
            <v-form>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        label="Search"
                        append-icon="mdi-magnify"
                        dense
                    >
                    </v-text-field>
                    <v-spacer />
                    <v-spacer />
                    <v-btn
                        class="ml-1"
                        fab
                        large
                        color="secondary"
                        icon
                        @click="openClearModal()"
                        exact
                    >
                        <v-icon large>mdi-plus-circle</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="Users"
                        :search="search"
                    >
                        <template v-slot:item.roles="{ item }">
                            <v-chip
                                v-for="role in item.roles"
                                :key="role.id"
                                color="primary"
                                dark
                                class="ma-2"
                                label
                            >
                                {{ role.name }}
                            </v-chip>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-select
                                v-model="item.status"
                                :items="['ACTIVE', 'INACTIVE']"
                                label="Status"
                                hide-details
                                solo
                                dense
                            ></v-select>
                            <v-spacer />
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn
                                small
                                class="mx-3"
                                color="info"
                                plain
                                @click="openModal(item)"
                            >
                                Edit/View
                            </v-btn>
                            <v-btn
                                small
                                class="mx-3"
                                color="error"
                                plain
                                @click="deleteItem(item)"
                            >
                                Delete User
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-form>
        </v-card>
        <v-dialog
            v-model="dialog"
            persistent
            width="80vw"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{ modalTitle }} user</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="user.name"
                                    :rules="[v => !!v || 'Name is required']"
                                    label="Name"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    label="Username"
                                    v-model="user.email"
                                    :rules="[v => !!v || 'Name is required']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="user.password"
                                    :append-icon="
                                        show ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    :type="show ? 'text' : 'password'"
                                    label="Password"
                                    @click:append="show = !show"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-combobox
                                    v-model="user.rol"
                                    :rules="[v => !!v || 'Rol is required']"
                                    :items="Roles"
                                    :item-text="'name'"
                                    :item-value="'name'"
                                    label="Select rol"
                                    auto-select-first
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row justify="end" class="px-5">
                            <v-btn
                                class="mx-5"
                                small
                                @click="dialog = false"
                                color="secondary"
                                >Cancel</v-btn
                            >
                            <v-btn small @click="validate()" color="secondary"
                                >Save</v-btn
                            >
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import DynamicToolbar from '@/components/Global/Utils/DynamicToolbar.vue';
export default {
    directives: {
        mask
    },
    components: {
        DynamicToolbar
    },
    data: function() {
        return {
            modalTitle: 'Create',
            users: [],
            activityTypes: [],
            search: '',
            start_date: '',
            end_date: '',
            show: '',
            user: {
                name: '',
                email: '',
                password: '',
                roles: [{}]
            },
            nameRules: [
                v => !!v || 'Name is required',
                v =>
                    (v && v.length <= 10) ||
                    'Name must be less than 10 characters'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
            ],
            Users: [],
            Roles: [],
            dialog: false,
            headers: [
                {
                    text: 'User',
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Rol',
                    value: 'roles'
                },
                {
                    text: 'Username',
                    value: 'email'
                },
                {
                    text: 'Status',
                    value: 'status'
                },
                {
                    text: 'Actions',
                    align: 'right',
                    value: 'actions',
                    sortable: false
                }
            ],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },

    mounted() {
        this.loadUsers();
        this.loadRoles();
    },

    methods: {
        loadUsers: function() {
            this.$store.state.isLoading = true;
            console.log('Loading Users');

            axios
                .get('/user', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.Users = response.data;
                    console.log(this.Users);
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        loadRoles: function() {
            this.$store.state.isLoading = true;
            console.log('Loading Roles');

            axios
                .get('/rol', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.Roles = response.data;
                    console.log(this.Roles);
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        openModal(item) {
            this.dialog = true;
            this.user = item;
            if (this.user.roles[0] == null) {
                this.user.roles[0] = [{}];
            } else {
                this.user.rol = this.user.roles[0].name;
            }
            this.requestType = 'edit';
            console.log(item);
        },
        openClearModal() {
            this.dialog = true;
            this.requestType = 'create';
            this.user = {
                name: '',
                email: '',
                password: '',
                roles: [{}]
            };
        },
        //Function validate return false if the form is empty
        validate() {
            if (this.$refs.form.validate()) {
                this.saveUser();
            } else {
                this.$store.dispatch('setSnackbar', {
                    color: 'red darken-4',
                    text: 'Empty fields error '
                });
            }
        },
        saveUser: function() {
            this.$store.state.isLoading = true;
            console.log('Updating');
            console.log(this.user);
            var params = {
                name: this.user.name,
                rol: this.user.rol.name,
                email: this.user.email,
                password: this.user.password
            };
            if (this.requestType == 'edit') {
                axios
                    .put('/user/' + this.user.id, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        this.dialog = false;
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Data saved successfully'
                        });
                        this.loadUsers();
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }

            if (this.requestType == 'create') {
                axios
                    .post('/user', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        this.dialog = false;
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'User created successfully'
                        });
                        this.loadUsers();
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }

            this.$store.state.isLoading = false;
        }
    }
};
</script>

<style scoped>
.v-dialog__content--active {
    background-color: #212121;
}

.v-dialog__content {
    opacity: 0.994;
}
</style>
